// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* TODO: remove after design approvement */
  /* scrollbar-width: none;
  -ms-overflow-style: none; 
  overflow-y: hidden; */
  scrollbar-face-color: '#D7D7D7'; /* Firefox 63 compatibility */
  scrollbar-track-color: 'transparent';
  scrollbar-color: '#D7D7D7 transparent';
  scrollbar-width: 'thin';
}

/* TODO: remove after design approvement */
/* body::-webkit-scrollbar {
  display: none;
} */

body::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
/* Track */
body::-webkit-scrollbar-track {
  background: transparent;
}
/* Handle */
body::-webkit-scrollbar-thumb {
  background: #D7D7D7;
  border-radius: 14px;
}
/* Handle on hover */
body::-webkit-scrollbar-thumb:hover {
  background: #BACBD9;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,0CAA0C;EAC1C;;uBAEqB;EACrB,+BAA+B,EAAE,6BAA6B;EAC9D,oCAAoC;EACpC,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA,0CAA0C;AAC1C;;GAEG;;AAEH;EACE,UAAU;EACV,WAAW;AACb;AACA,UAAU;AACV;EACE,uBAAuB;AACzB;AACA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE;aACW;AACb","sourcesContent":["body {\n  margin: 0;\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* TODO: remove after design approvement */\n  /* scrollbar-width: none;\n  -ms-overflow-style: none; \n  overflow-y: hidden; */\n  scrollbar-face-color: '#D7D7D7'; /* Firefox 63 compatibility */\n  scrollbar-track-color: 'transparent';\n  scrollbar-color: '#D7D7D7 transparent';\n  scrollbar-width: 'thin';\n}\n\n/* TODO: remove after design approvement */\n/* body::-webkit-scrollbar {\n  display: none;\n} */\n\nbody::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n/* Track */\nbody::-webkit-scrollbar-track {\n  background: transparent;\n}\n/* Handle */\nbody::-webkit-scrollbar-thumb {\n  background: #D7D7D7;\n  border-radius: 14px;\n}\n/* Handle on hover */\nbody::-webkit-scrollbar-thumb:hover {\n  background: #BACBD9;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
